import { fetchConfigToken, logger } from '@/sdk/oauth'
import store from '@/store'

const getAndSaveConfigToken = () => {
  logger(
    'oauth/configToken -> getAndSaveConfigToken -> deleting token saved in localStorage',
  )
  store.commit('auth/deleteConfigToken')

  return fetchConfigToken()
    .then(response => {
      logger(
        'oauth/configToken -> getAndSaveConfigToken -> fetchConfigToken was successful',
      )
      store.commit('auth/setConfigToken', response.data.access_token)
      return true
    })
    .catch(error => error)
}

export default getAndSaveConfigToken
